import { NgModule, ModuleWithProviders, TemplateRef } from '@angular/core';
import { NgbTooltipModule, NgbCollapseModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { VsModuleConfig } from './models/module-config';
import { ModuleConfigService, moduleConfigFunc } from './services/module-config.service';
import {
    FileUploadModule,
    DropdownModule,
    TooltipModule,
    MultiSelectModule,
    AutoCompleteModule,
    CalendarModule,
    DialogModule,
    ScrollPanelModule,
    BreadcrumbModule,
    LightboxModule,
    DialogService,
    PanelModule,
    InputSwitchModule,
    CheckboxModule,
    DynamicDialogConfig,
    RadioButtonModule
} from 'primeng/primeng';

import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { VsPrintOnDebugPipe } from './pipes/print-object.pipe';
import { VsQueryStringService } from './services/query-string.service';
import { DateOnlyDirective } from './directives/date-only.directive';
import { VsCommonService } from './services/vs-common.service';
import { VsThongBaoService } from './services/vs-thongbao.service';
import { VsApplicationManagementService } from './services/application-management.service';
import { VsDateTimePipe, VsDatePipe } from './pipes/date.pipe';

import { ShowDefaultImageOnErrorDirective } from './directives/show-default-image-on-error.directive';
import { RouterModule } from '@angular/router';
import { ConfirmDirective } from './directives/confirm.directive';
import { AccountTypePipe } from './pipes/account-type.pipe';
import { ApprovalPipe } from './pipes/approval.pipe';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { VsUserRolePipe } from './pipes/user-role.pipe';
import { TNThietLapCauHinhService } from './services/cau-hinh-thiet-lap.service';
import { ConfirmSwalDirective } from './directives/confirm-swal.directive';
import { ErrorInterceptor } from './intercepters/error-intercepter';
// import { AuthorizationIntercepter } from './auth/authorization-intercepter';
import { ConfigurationService } from './services/configuration.service';
// import { PhanTramPipe } from 'lib-shared';
import { LogSessionIntercepter } from './intercepters/log-session.intercepter';
import { AuthorizeDirective } from './directives/authorize.directive';
import { VsFsFolderPickerComponent } from './components/file-upload/fs-folder-picker/fs-folder-picker.component';
import { VsFileUploadService } from './components/file-upload/services/file-upload.service';
import { BreadcrumbComponent } from './components/file-upload/breadcrumb/breadcrumb.component';
import { FileManagerPopupComponent } from './components/file-upload/file-manager-popup/file-manager-popup.component';
import { FileViewerComponent } from './components/file-upload/file-viewer/file-viewer.component';
import { TNSelectFileOnServerComponent } from './components/file-upload/select-file-onserver/select-file-onserver.component';
import { TableModule } from 'primeng/table';
import { AuthorizationIntercepter } from './intercepters/authorization-intercepter';
import { VsFsListFileComponent } from './components/file-upload/list-file/list-file.component';
import { VsFsListImageComponent } from './components/file-upload/list-image/list-image.component';
import { ValidationSummaryComponent } from './components/validation-summary/validation-summary.component';
import { VsAppNotificationComponent } from './components/app-notification/app-notification.component';
import { BlockableDivComponent } from './components/blockable/blockable-div/blockable-div.component';
import { BooleanFormatPipe } from './pipes/boolean-format.pipe';
import { ConvertMoneyToWordPipe } from './pipes/convertMoneyToWord.pipe';
import { FileIconPipe } from './pipes/file-icon.pipe';
import { HighlightSearchPipe } from './pipes/highlight.pipe';
import { StringFormatPipe } from './pipes/string-format.pipe';
import { SummaryPipe } from './pipes/summary.pipe';
import { TrangThaiPipe } from './pipes/trangThai.pipe';
import { VsFileSizePipe, VsGetRawFileNamePipe } from './pipes/file-size.pipe';
import { NotificationService } from './services/notification.service';
import { UserService } from './services/user.service';
import { VsViewImageComponent } from './components/file-upload/view-image/view-image.component';
import { CustomRouterService } from './services/custom-router.service';
import { TopicUsersService } from './services/topicusers.service';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { AutofocusDirective } from './directives/autofocus.directive';
import { FoldersService } from './components/file-upload/services/folders.service';
import { FilesService } from './components/file-upload/services/files.service';
import { SafePipe } from './pipes/safe.pipe';
import { VsNumberPipe } from './pipes/vs-number.pipe';
import { VsFileUploadComponent } from './components/file-upload/vs-file-upload/vs-file-upload.component';
import { FileuploadFilemanagerComponent } from './components/file-upload/fileupload-filemanager/fileupload-filemanager.component';
import { UserViewComponent } from './components/user-view/user-view.component';
import { PasteClipboardDirective } from './directives/paste-clipboard.directive';
import { OutsideClickDirective } from './directives/outsite-click.directive';
import { VsAvatarViewComponent } from './components/vs-avatar-view/vs-avatar-view.component';
import { HqFileViewCommentComponent } from './components/file-upload/hq-file-view-comment/hq-file-view-comment.component';
import { HqFileUploadCommentComponent } from './components/file-upload/hq-file-upload-comment/hq-file-upload-comment.component';
import { UserInformationComponent } from './components/user-information/user-information.component';
import { UserInformationTdvEditComponent } from './components/user-information-tdv-edit/user-information-tdv-edit.component';
import { UserAddressDeliveryComponent } from './components/user-address-delivery/user-address-delivery.component';
import { UserAddressDeliveryEditComponent } from './components/user-address-delivery/user-address-delivery-edit/user-address-delivery-edit.component';
import { LogUserChangesComponent } from './components/log-user-changes/log-user-changes.component';
import { UserLogService } from './services/user-log.service';
import { HoverImageToolTipDirective } from './directives/hover-image-toolTip.directive';
import { DateFilterControlComponent } from './components/date-filter-control/date-filter-control.component';
import { YearPickerComponent } from './components/year-picker/year-picker.component';
import { ApprovalPanelComponent } from './components/approval-panel/approval-panel.component';
import { DocumentViewerComponent } from './components/file-upload/document-viewer/document-viewer.component';
import { VsViewDatePipe } from './pipes/vs-viewDate.pipe';
import { VsTreeOrganizationComponent } from './components/vs-tree-organization/vs-tree-organization.component';

export function coreDeclarations() {
    return [
        VsPrintOnDebugPipe,
        VsDateTimePipe,
        VsDatePipe,
        VsUserRolePipe,
        DateOnlyDirective,
        AutofocusDirective,
        ShowDefaultImageOnErrorDirective,
        ConfirmDirective,
        ConfirmSwalDirective,
        AccountTypePipe,
        ApprovalPipe,
        AuthorizeDirective,
        VsFsFolderPickerComponent,
        FileViewerComponent,
        DocumentViewerComponent,
        BreadcrumbComponent,
        FileManagerPopupComponent,
        TNSelectFileOnServerComponent,
        VsFileUploadComponent,
        FileuploadFilemanagerComponent,
        VsFsListFileComponent,
        VsFsListImageComponent,
        ValidationSummaryComponent,
        VsAppNotificationComponent,
        BlockableDivComponent,
        BooleanFormatPipe,
        ConvertMoneyToWordPipe,
        FileIconPipe,
        VsFileSizePipe,
        VsGetRawFileNamePipe,
        HighlightSearchPipe,
        StringFormatPipe,
        SummaryPipe,
        SafePipe,
        TrangThaiPipe,
        VsViewImageComponent,
        VsNumberPipe,
        VsViewDatePipe,
        UserViewComponent,
        PasteClipboardDirective,
        HoverImageToolTipDirective,
        OutsideClickDirective,
        VsAvatarViewComponent,
        HqFileViewCommentComponent,
        HqFileUploadCommentComponent,
        UserInformationComponent,
        UserAddressDeliveryComponent,
        UserAddressDeliveryEditComponent,
        UserInformationTdvEditComponent,
        LogUserChangesComponent,
        DateFilterControlComponent,
        VsTreeOrganizationComponent,
        YearPickerComponent,
        ApprovalPanelComponent
    ];
}

export function coreProviders() {
    return [
        DialogService,
        TopicUsersService,
        CustomRouterService,
        UserService,
        NotificationService,
        ConfigurationService,
        ModuleConfigService,
        VsQueryStringService,
        VsCommonService,
        VsThongBaoService,
        VsApplicationManagementService,
        TNThietLapCauHinhService,
        VsFileUploadService,
        FoldersService,
        FilesService,
        UserLogService,
        DynamicDialogConfig,
        DialogService,
        // NotifierService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: LogSessionIntercepter,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthorizationIntercepter,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ErrorInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ErrorInterceptor,
            multi: true
        }
    ];
}

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        InputSwitchModule,
        ReactiveFormsModule,
        DropdownModule,
        FileUploadModule,
        TooltipModule,
        MultiSelectModule,
        AutoCompleteModule,
        NgbTooltipModule,
        NgbCollapseModule,
        CalendarModule,
        NgbModule,
        DialogModule,
        TableModule,
        ScrollPanelModule,
        BreadcrumbModule,
        InfiniteScrollModule,
        LightboxModule,
        PanelModule,
        CheckboxModule,
        RadioButtonModule,
    ],
    entryComponents: [
        DocumentViewerComponent,
        FileViewerComponent,
        UserViewComponent,
        UserAddressDeliveryComponent,
        UserAddressDeliveryEditComponent,
    ],
    declarations: coreDeclarations(),
    exports: coreDeclarations(),
    providers: coreProviders()
})
export class VsSharedModule {
    static forRoot(config?: any): ModuleWithProviders {
        return {
            ngModule: VsSharedModule,
            providers: [
                {
                    provide: moduleConfigFunc,
                    useValue: config
                }
            ]
        };
    }
}
